(() => {
  document.querySelectorAll('[data-pdp]').forEach((pdp) => {
    const main = pdp.querySelector('.pdp__img');
    pdp.querySelectorAll('[data-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = btn.dataset.src;
        pdp.querySelectorAll('[data-thumb]').forEach((b) => b.classList.toggle('is-active', b === btn));
      });
    });
    const sticky = pdp.querySelector('[data-sticky]');
    const form = pdp.querySelector('.pform');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(form);
    }
  });
  document.querySelectorAll('[data-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  document.querySelectorAll('.vband video').forEach((v) => {
    v.muted = true;
    v.setAttribute('playsinline', '');
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  });
})();

(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isEs = (document.documentElement.lang || 'es').toLowerCase().startsWith('es');
  const txt = {
    added: isEs ? 'Agregado al carrito' : 'Added to cart',
    view: isEs ? 'Ver carrito' : 'View cart',
    error: isEs ? 'No pudimos agregarlo. Intenta de nuevo.' : 'Could not add it. Try again.'
  };

  const toast = (message, ok) => {
    let box = document.querySelector('[data-fierro-toast]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-fierro-toast', '');
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      box.style.cssText = 'position:fixed;left:50%;top:calc(16px + env(safe-area-inset-top,0px));transform:translateX(-50%);z-index:60;display:flex;align-items:center;justify-content:space-between;gap:14px;width:max-content;max-width:calc(100vw - 32px);box-sizing:border-box;padding:12px 12px 12px 18px;border-radius:4px;background:var(--ink,#0E0E0C);color:var(--bg,#F4F1EA);font-weight:700;font-size:15px;box-shadow:0 8px 24px rgba(0,0,0,.3)';
      document.body.appendChild(box);
    }
    box.innerHTML = '';
    const span = document.createElement('span');
    span.textContent = (ok ? '\u2713 ' : '') + message;
    span.style.cssText = 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0';
    box.appendChild(span);
    if (ok) {
      const link = document.createElement('a');
      link.href = root + 'cart';
      link.textContent = txt.view;
      link.style.cssText = 'background:var(--accent,#FFD000);color:var(--ink,#0E0E0C);padding:8px 12px;border-radius:4px;text-decoration:none;text-transform:uppercase;font-size:13px;font-weight:800;white-space:nowrap';
      box.appendChild(link);
    }
    box.style.display = 'flex';
    clearTimeout(box._t);
    box._t = setTimeout(() => { box.style.display = 'none'; }, 5000);
  };

  const updateBadge = (count) => {
    document.querySelectorAll('a.iconbtn[href$="/cart"]').forEach((a) => {
      let badge = a.querySelector('.badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'badge';
        a.appendChild(badge);
      }
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
  };

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.pform__cart');
    if (!btn) return;
    const form = btn.closest('form') || document.getElementById(btn.dataset.form);
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    const data = new FormData(form);
    const id = data.get('id');
    const quantity = parseInt(data.get('quantity') || '1', 10) || 1;
    btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      updateBadge(cart.item_count);
      toast(txt.added, true);
      btn.classList.add('is-done');
      setTimeout(() => btn.classList.remove('is-done'), 1500);
    } catch (e) {
      toast(txt.error, false);
    } finally {
      btn.disabled = false;
    }
  }, true);
})();

(() => {
  const sec = document.querySelector('[data-cart-section]');
  if (!sec) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sid = sec.dataset.cartSection;
  const timers = {};

  const setBadge = (count) => {
    document.querySelectorAll('a.iconbtn[href$="/cart"]').forEach((a) => {
      let badge = a.querySelector('.badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'badge';
        a.appendChild(badge);
      }
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
  };

  const change = async (line, quantity) => {
    const list = sec.querySelector('.cart');
    if (list) list.classList.add('is-busy');
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity, sections: [sid], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || !data.sections) throw new Error('change failed');
      if (data.item_count === 0) { window.location.reload(); return; }
      const doc = new DOMParser().parseFromString(data.sections[sid], 'text/html');
      const newList = doc.querySelector('.cart');
      const newTotal = doc.querySelector('[data-cart-total]');
      const oldTotal = sec.querySelector('[data-cart-total]');
      if (newList && list) list.replaceWith(newList);
      if (newTotal && oldTotal) oldTotal.replaceWith(newTotal);
      setBadge(data.item_count);
    } catch (e) {
      window.location.reload();
    }
  };

  const schedule = (line, quantity) => {
    clearTimeout(timers[line]);
    timers[line] = setTimeout(() => change(line, quantity), 400);
  };

  sec.addEventListener('click', (event) => {
    const step = event.target.closest('.qbtn');
    if (step) {
      const wrap = step.closest('[data-line]');
      const input = wrap.querySelector('[data-qty]');
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.step));
      input.value = next;
      schedule(wrap.dataset.line, next);
      return;
    }
    const rm = event.target.closest('[data-remove]');
    if (rm) {
      event.preventDefault();
      change(rm.dataset.line, 0);
    }
  });

  sec.addEventListener('change', (event) => {
    const input = event.target.closest('[data-qty]');
    if (!input) return;
    const wrap = input.closest('[data-line]');
    schedule(wrap.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
  });

  sec.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('[data-qty]')) {
      event.preventDefault();
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();

(() => {
  const fallback = document.querySelector('[data-cod-fallback]');
  if (!fallback) return;
  const foot = fallback.closest('.cart__foot') || document;
  const hasRelease = () => Array.from(foot.querySelectorAll('button, a, [role="button"]')).some((el) => {
    if (el === fallback) return false;
    const tag = ((el.className && el.className.toString()) || '') + ' ' + (el.id || '');
    return /_rsi|releasit/i.test(tag) && el.offsetParent !== null && el.offsetHeight > 20;
  });
  const sync = () => { fallback.style.display = hasRelease() ? 'none' : ''; };
  sync();
  new MutationObserver(sync).observe(foot, { childList: true, subtree: true });
})();
